<div class="se-side-details-item_outer-container">
    <div *ngIf="!!title" class="se-side-details-item__title-container text-center">
        <span class="se-side-details-item__title">{{title | translate}}</span>
    </div>
    <div class="se-side-details-item__container">
        <div *ngFor="let detail of details">
            <span #key class="se-side-detail__key" *ngIf="!detail.estensaColDef.hide && !detail.estensaColDef.estensaDetails.primary && detail.estensaColDef.headerName"
                  matTooltip="{{detail.estensaColDef.headerName | translate}}" positionAtOrigin="true" [matTooltipDisabled]="_isTooltipDisabled(key)">
                {{detail.estensaColDef.headerName | translate | uppercase}} : 
            </span>
            <span #value class="se-side-detail__value" *ngIf="!detail.estensaColDef.hide && !detail.estensaColDef.estensaDetails.primary && detail.estensaColDef.headerName"
                  matTooltip="{{detail.value}}" positionAtOrigin="true" [matTooltipDisabled]="_isTooltipDisabled(value)">
                {{ detail.value}}
            </span>
        </div>
    </div>

</div>
